import {
  Component,
  OnInit,
  Input,
  Inject,
  Output,
  EventEmitter
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface Data {
  app: any;
  clientId?: any;
}
@Component({
  standalone: false,
  selector: 'app-user-apps-details',
  templateUrl: './user-apps-details.component.html',
  styleUrls: ['./user-apps-details.component.scss']
})
export class UserAppsDetailsComponent implements OnInit {
  app: any;
  isInternal: boolean;
  @Input()
  bordercss: boolean;
  @Input()
  error: string;
  @Output() isInternalCheck = new EventEmitter();
  constructor(@Inject(MAT_DIALOG_DATA) public data: Data) {
    this.app = this.data.app;
    this.isInternal = false;
  }

  ngOnInit() {}
  getInitial(app) {
    if (!app.name) {
      return;
    }

    return `${app.name[0].toUpperCase()}${app.name[
      app.name.length - 1
    ].toUpperCase()}`;
  }

  select(event) {
    this.isInternalCheck.emit(event.checked);
  }
}
